<div class="row">
    <!--
        ============================
        Gestion des intérêts
        ============================
    -->
    <div class="col-12 mt-2" *ngIf="dataLoaded | async">
        <div class="row align-items-center">
            <div class="col-md-12 col-9" *ngIf="!hideTitle">
                <h2 class="h3 primary-1" [ngSwitch]="context">
                    <span *ngSwitchCase="'project'">
                        {{ 'projects.formStep3.interests.associateInterests' | translate }}
                    </span>
                    <span *ngSwitchDefault> {{ 'projects.formStep3.interests.manageInterests' | translate }} </span>
                </h2>
            </div>
            <div class="col-auto d-block d-md-none ml-auto">
                <button
                    class="btn btn-add-remove add btn-primary mb-1"
                    data-toggle="modal"
                    data-target="#modalInterests"
                    type="button"
                >
                    <em>+</em>
                </button>
            </div>
        </div>

        <!-- Modal Interets (utilisé pour le mobile) -->
        <div
            class="modal fade bd-example-modal-lg"
            id="modalInterests"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modalInterests"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <!-- Domaines d'intérêt -->
                    <div class="card-filter">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <h3 class="h6 primary-1">
                                        {{ 'projects.formStep3.interests.interestsDomain' | translate }}
                                    </h3>
                                    <input
                                        type="search"
                                        [placeholder]="interestsDomainPlaceholder"
                                        class="form-control"
                                        (input)="onInterestDomainSearchTextChanged($event.target.value)"
                                    />
                                </div>
                            </div>
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item" *ngFor="let interestDomain of visibleInterestDomains">
                                <input
                                    type="checkbox"
                                    aria-label="..."
                                    id="{{ interestDomain.key }}"
                                    [(ngModel)]="interestDomain.checked"
                                    (change)="onCheckedInterestDomain()"
                                />
                                <label for="{{ interestDomain.key }}" class="mb-0">{{ interestDomain.value }}</label>
                            </li>
                        </ul>
                    </div>
                    <!-- /domaines d'intérêt -->
                    <!-- Centres d'intérêt -->
                    <div class="card-filter">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <h3 class="h6 primary-1">
                                        {{ 'projects.formStep3.interests.interests' | translate }}
                                    </h3>
                                    <input
                                        type="search"
                                        [placeholder]="interstsPlaceHolder"
                                        class="form-control"
                                        (input)="onInterestSearchTextChanged($event.target.value)"
                                    />
                                </div>
                            </div>
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item" *ngFor="let interest of visibleInterests">
                                <div class="row align-items-center">
                                    <div class="col-auto w-75">
                                        {{ interest.value }}
                                    </div>
                                    <div
                                        class="col-auto ml-auto"
                                        *ngIf="checkIfHasInterest(interest.key); else elseBlockInterests"
                                    >
                                        <button
                                            class="btn btn-primary btn-add-remove remove"
                                            type="button"
                                            (click)="removeInterest(interest.key)"
                                        >
                                            <em>-</em>
                                        </button>
                                    </div>
                                    <ng-template #elseBlockInterests>
                                        <div class="col-auto ml-auto">
                                            <button
                                                class="btn btn-primary btn-add-remove add"
                                                type="button"
                                                [disabled]="maximumInterests"
                                                (click)="addInterest(interest.key)"
                                            >
                                                <em>+</em>
                                            </button>
                                        </div>
                                    </ng-template>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- /centres d'intérêt -->

                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal">
                            {{ 'components.button.buttonClose' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- /modal interets -->

        <div class="row">
            <!-- Selection intérets -->
            <div class="col-md-8 d-none d-md-block">
                <div class="card box-shadow">
                    <div class="row no-gutters row-eq-height">
                        <!-- CENTRES D'INTERETS -->
                        <div class="col-6 gestion-selection">
                            <div class="card-body">
                                <h3 class="h6 primary-1">
                                    {{ 'projects.formStep3.interests.interestsDomain' | translate }}
                                </h3>
                                <input
                                    type="search"
                                    [placeholder]="interestsDomainPlaceholder"
                                    class="form-control"
                                    (input)="onInterestDomainSearchTextChanged($event.target.value)"
                                />
                            </div>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item" *ngFor="let interestDomain of visibleInterestDomains">
                                    <input
                                        type="checkbox"
                                        aria-label="..."
                                        id="{{ interestDomain.key }}"
                                        [(ngModel)]="interestDomain.checked"
                                        (change)="onCheckedInterestDomain()"
                                    />
                                    <label for="{{ interestDomain.key }}" class="mb-0">{{
                                        interestDomain.value
                                    }}</label>
                                </li>
                            </ul>
                        </div>
                        <!-- /CENTRES D'INTERETS -->
                        <!-- INTERETS DISPONIBLES -->
                        <div class="col-md-6 col-12">
                            <div class="card-body">
                                <h3 class="h6 primary-1">
                                    {{ 'projects.formStep3.interests.availableInterests' | translate }}
                                </h3>
                                <input
                                    type="search"
                                    [placeholder]="interstsPlaceHolder"
                                    class="form-control"
                                    (input)="onInterestSearchTextChanged($event.target.value)"
                                />
                            </div>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item" *ngFor="let interest of visibleInterests">
                                    <div class="row align-items-center">
                                        <div class="col-auto w-75">
                                            {{ interest.value }}
                                        </div>
                                        <div
                                            class="col-auto ml-auto"
                                            *ngIf="checkIfHasInterest(interest.key); else elseBlockInterests"
                                        >
                                            <button
                                                class="btn btn-primary btn-add-remove add"
                                                type="button"
                                                [disabled]="true"
                                                (click)="addInterest(interest.key)"
                                            >
                                                <em>+</em>
                                            </button>
                                        </div>
                                        <ng-template #elseBlockInterests>
                                            <div class="col-auto ml-auto">
                                                <button
                                                    class="btn btn-primary btn-add-remove add"
                                                    type="button"
                                                    [disabled]="maximumInterests"
                                                    (click)="addInterest(interest.key)"
                                                >
                                                    <em>+</em>
                                                </button>
                                            </div>
                                        </ng-template>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <!-- /INTERETS DISPONIBLES -->
                    </div>
                </div>
            </div>
            <!-- /selection intérets -->
            <!-- Mes intérets -->
            <div class="col-md-4">
                <div class="card card-project-active box-shadow">
                    <div class="card-body">
                        <h3 class="h6">
                            <ng-container [ngSwitch]="context">
                                <span *ngSwitchCase="'profile'">
                                    {{ 'projects.formStep3.interests.myInterests' | translate }}
                                </span>
                                <span *ngSwitchCase="'project'">
                                    {{ 'projects.formStep3.interests.associatedInterests' | translate }}
                                </span>
                                <span *ngSwitchDefault>
                                    {{ 'projects.formStep3.interests.selectedInterests' | translate }}
                                </span>
                            </ng-container>
                            <span class="float-right">{{ currentInterests?.length || 0 }}/{{ maxInterests }}</span>
                        </h3>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" *ngFor="let interest of currentInterests" [value]="interest.id">
                            <div class="row align-items-center">
                                <div class="col-auto w-75">
                                    {{ interest.name | wtranslate: 'interests' }}
                                </div>
                                <div class="col-auto ml-auto">
                                    <button
                                        class="btn btn-light btn-add-remove remove"
                                        type="button"
                                        (click)="removeInterest(interest.id)"
                                    >
                                        <em>-</em>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- /mes interets -->
        </div>
    </div>
</div>
